ready().then(function() {

    /**
    * We need to overwrite styles which come from an external source
    * https://weekbladpersgroep.atlassian.net/browse/VER-5956
    *
    * Done with css to avoid layout shifts for Google page speed
    * Afterwards, we rewrite the html by JS (blurb.js), to avoid double <h1> tags occur in the html - which is bad for SEO purposes
    */

    const blurbAdjustments = () => {
        const blurb = document.getElementsByClassName("book-blurb");

        if (typeof(blurb) != 'undefined' && blurb != null) {
            for (let item of blurb) {
                item.innerHTML.replace(/h1./g, 'h2'); // loop through the found items and replace them with a small regex
            }
        }
    }
    
    blurbAdjustments();
});